import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {PublicMessage} from '@model/public-message';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';


@Component({
    selector: 'app-public-message',
    templateUrl: './public-message.component.html',
    styleUrls: ['./public-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatIconModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule]
})
export class PublicMessageComponent implements OnInit, OnChanges {

  @Input()
  publicMessage: PublicMessage;

  @Input()
  isAdminStaffMember: boolean;

  @Output()
  publicMessageSave: EventEmitter<PublicMessage> = new EventEmitter();

  editMode = false;
  publicMessageForm: UntypedFormGroup;

  constructor(private _formBuilder: UntypedFormBuilder ) { }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges() {
    this.initForm();
  }

  private initForm() {
    this.publicMessageForm = this._formBuilder.group({
      publicMessage: [this.publicMessage?.text, [Validators.maxLength(500)]]
    });
  }

  save() {
    this.publicMessageSave.emit({text: this.publicMessageForm.get('publicMessage').value || ''});
    this.editMode = false;
  }
}
